import { render } from "./Customer_Modal.vue?vue&type=template&id=27bee45a"
import script from "./Customer_Modal.vue?vue&type=script&lang=js"
export * from "./Customer_Modal.vue?vue&type=script&lang=js"

import "./Customer_Modal.vue?vue&type=style&index=0&id=27bee45a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__